<app-data-grid
  [dataItems]="gridData"
  [group]="group"
  [state]="state"
  [columns]="columns"
  [filterable]="'menu'"
  [fontSize]="fontSize"
  (dataStateChange)="onDataStateChanged($event)"
  (filterChange)="filterChanged($event)"
>
  <ng-template
    filterTemplate
    let-column="column"
    let-filterService="filterService"
    field="parItemId"
  >
    <app-custom-filter
      [view]="customFilterView"
      [lazy]="false"
      [filter]="state.filter"
      [preselected]="filterCache.get(column.field) || []"
      (filterChanged)="
        onCustomFilterChange(column.field, $event, filterService)
      "
      [field]="column.field"
      [type]="column.type"
    ></app-custom-filter>
  </ng-template>

  <ng-template
    filterTemplate
    let-column="column"
    let-filterService="filterService"
    field="componentParId"
  >
    <app-custom-filter
      [view]="customFilterView"
      [lazy]="false"
      [filter]="state.filter"
      [preselected]="filterCache.get(column.field) || []"
      (filterChanged)="
        onCustomFilterChange(column.field, $event, filterService)
      "
      [field]="column.field"
      [type]="column.type"
    ></app-custom-filter>
  </ng-template>

  <ng-template
    filterTemplate
    let-column="column"
    let-filterService="filterService"
    field="itemName"
  >
    <app-custom-filter
      [view]="customFilterView"
      [lazy]="false"
      [filter]="state.filter"
      [preselected]="filterCache.get(column.field) || []"
      (filterChanged)="
        onCustomFilterChange(column.field, $event, filterService)
      "
      [field]="column.field"
      [type]="column.type"
    ></app-custom-filter>
  </ng-template>

  <ng-template
    filterTemplate
    let-column="column"
    let-filterService="filterService"
    field="componentName"
  >
    <app-custom-filter
      [view]="customFilterView"
      [lazy]="false"
      [filter]="state.filter"
      [preselected]="filterCache.get(column.field) || []"
      (filterChanged)="
        onCustomFilterChange(column.field, $event, filterService)
      "
      [field]="column.field"
      [type]="column.type"
    ></app-custom-filter>
  </ng-template>

  <ng-template
    filterTemplate
    let-column="column"
    let-filterService="filterService"
    field="componentType"
  >
    <app-custom-filter
      [view]="customFilterView"
      [lazy]="false"
      [filter]="state.filter"
      [preselected]="filterCache.get(column.field) || []"
      (filterChanged)="
        onCustomFilterChange(column.field, $event, filterService)
      "
      [field]="column.field"
      [type]="column.type"
    ></app-custom-filter>
  </ng-template>

  <ng-template
    filterTemplate
    let-column="column"
    let-filterService="filterService"
    field="restaurantNo"
  >
    <app-custom-filter
      [view]="customFilterView"
      [lazy]="false"
      [filter]="state.filter"
      [preselected]="filterCache.get(column.field) || []"
      (filterChanged)="
        onCustomFilterChange(column.field, $event, filterService)
      "
      [field]="column.field"
      [type]="column.type"
    ></app-custom-filter>
  </ng-template>

  <ng-template #toolbarTemplate>
    <div class="k-toolbar k-grid-toolbar custom-toolbar">
      <h4 class="m-0">Pricing Mismatches in Tier:</h4>
      &nbsp;
      <div class="filters-section">
        <kendo-dropdownlist
          [data]="tiers"
          class="tier-dropdown"
          [(ngModel)]="selectedTier"
          textField="name"
          valueField="id"
          (ngModelChange)="setDefaultState()"
        >
          <ng-template kendoDropDownListValueTemplate let-dataItem>
            <span class="selected-tier">
              <fa-icon
                class="lock-icon"
                *ngIf="dataItem?.isLocked ?? false"
                [icon]="['fas', 'lock']"
              ></fa-icon>
              {{ dataItem?.name }} -
              <strong
                ><fa-icon
                  class="king-icon icon-text"
                  [icon]="['fas', 'crown']"
                ></fa-icon
                >{{ dataItem?.kingRestaurantName }}
              </strong></span
            >
          </ng-template>
        </kendo-dropdownlist>
      </div>

      <div class="buttons-section">
        <span   
          kendoTooltip
          [title]="tierAlignEnabled ? 'Click to align this tier' : 'This feature is disabled while we work on improving accuracy.'">
            <button
              kendoButton
              [disabled]="tierAlignEnabled == false || (selectedTier.isLocked ?? false)"
              *ngIf="gridData && gridData.data.length > 0"
              (click)="alignTier()"
              themeColor="success"
              fillMode="solid"
              size="small"
            >
              Fix Tier
            </button>
        </span>

        <!-- <span   
          kendoTooltip
          [title]="tierAlignEnabled ? 'Click to align this tier' : 'This feature is disabled while we work on improving accuracy.'"> -->
            <!-- <button
              kendoButton
              [disabled]="tierAlignEnabled == false || (selectedTier.isLocked ?? false)"
              *ngIf="
                gridData &&
                gridData.data.length > 0 &&
                state.filter &&
                state.filter.filters.length > 0
              "
              (click)="alignTier(true)"
              themeColor="success"
              fillMode="solid"
              size="small"
            >
              Fix filter results only
            </button> -->
        <!-- </span> -->

        <app-grid-manager-toolbar
          [showConfig]="false"
          (exportToExcel)="exportTierMismatches()"
          [fontSize]="fontSize"
          (fontSizeChange)="fontSize = $event"
          [columns]="columns"
          [view]="'Tier Mismatches'"
          [showImport]="[]"
          [showExport]="['Current Type']"
        ></app-grid-manager-toolbar>
      </div>
    </div>
  </ng-template>

  <ng-template
    groupColumnHeaderTemplate
    field="groupKey"
    let-group="group"
    let-column="column"
  >
    <div class="k-gap-md k-d-flex k-justify-content-between">
      <!-- <button
        [disabled]="selectedTier.isLocked ?? false"
        (click)="fixMismatch(group.items[0])"
        class="m-l-2"
        kendoButton
        themeColor="success"
        fillMode="solid"
        size="small"
      >
        Fix Item
      </button> -->
      <span
        >{{ group.items[0]?.itemName }}
        {{
          group.items[0]?.componentName != null
            ? "- " +
              group.items[0]?.componentName +
              " (" +
              group.items[0]?.componentType +
              ")"
            : ""
        }}
      </span>
    </div>
  </ng-template>
</app-data-grid>
